import React, { useState } from "react";
import StepTabs from "../../../Components/Stepbar/Steptabs";
import UploadVideoGuides from "./Tabs/UploadVideoGuides";
import EditVideoGuides from "./Tabs/EditVideoGuides";
import UploadSupportInfo from "./Tabs/UploadSupport/UploadSuportInfo";
import EditSupportInfo from "./Tabs/EditSupport/EditSupportInfo";

const Resource = () => {
  const tabNames = [
    "Upload Video Guides",
    "Edit Video Guides ",
    "Upload Supporting Information",
    "Edit Supporting Information",
  ];
  return (
    <div className="main-resource-cont">
      <div className="resource-head">
        <div className="head-port">
          <h3>Upload Resources</h3>
          <p>Share your expertise through videos and FAQs,</p>
        </div>
      </div>

      <div className="resouce-tabs">
        <div className="developer-content">
          <StepTabs size={"large "} tabNames={tabNames}>
            <UploadVideoGuides />
            <EditVideoGuides />
            <UploadSupportInfo />
            <EditSupportInfo />
          </StepTabs>
        </div>
      </div>
    </div>
  );
};
export default Resource;
